import React from 'react';
import {Layout, Modal} from "antd";
import QwHeader from "../layout/header";
import {Route, Switch} from "react-router-dom";
import Contact from "../layout/contact";
import loadable from "../loadable";
import CorpApi from "../public/corp_api";

const Home = loadable(() => import('./home'));


const {Content} = Layout;

class Dashboard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isComplete: 1,
        }
    }

    componentWillMount() {
        CorpApi.getEnterpriseWechatAuthoriztionStuatus((data) => {
            let isComplete = data.isComplete;
            this.setState({
                isComplete: isComplete
            })
        })
        if (new Date().getTime() < 1676905200000) {
            Modal.error({
                title: '【重要】紫鲲商户收款功能下线通知',
                content: (
                    <div>
                        由于微信支付收款资金结算方式调整，紫鲲将于2023年2月19号中午12点下线紫鲲提供的微信商户收款功能。请使用紫鲲商户收款的商家尽快申请并配置自己的微信商户。
                        详情请见
                        <a className="text-primary" target="_blank"
                           href="https://pay.weixin.qq.com/index.php/public/cms/content_detail?lang=zh&id=126521">《收款资金结算方式调整通知》</a>
                        ，
                        <a className="text-primary" target="_blank"
                           href="https://pay.weixin.qq.com/index.php/public/cms/content_detail?lang=zh&id=126073">《企业付款到零钱产品调整通知》</a>
                    </div>
                ),
                okText: '知道了'
            })
        }
    }

    render() {
        return (
            <Layout className='qy-layout'>
                <QwHeader key='qyHeader' toggleSiderCollapsed={this.toggleSiderCollapsed} history={this.props.history}
                          type='1'/>
                <Layout>
                    <Content className='qy-content-wraper'>
                        <div className='qy-content'>
                            <Contact/>
                            <Switch>
                                <Route path={this.props.match.url + "/"} component={Home}/>
                            </Switch>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default Dashboard